import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { Collections } from './components/Collections';
import { Craft } from './components/Craft';
import { SignaturePiece } from './components/SignaturePiece';
import { Testimonials } from './components/Testimonials';
import { Appointment } from './components/Appointment';
import { Footer } from './components/Footer';
export function App() {
  return <div dir="rtl" className="min-h-screen bg-ivory text-charcoal selection:bg-gold selection:text-ivory font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Philosophy data-id="element-4" />
        <Collections data-id="element-5" />
        <Craft data-id="element-6" />
        <SignaturePiece data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Appointment data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}